module.exports = {
  "logo": {
    src: "logo.svg",
    height: 60,
  },
  "loginBackground": "login-background.jpg",
}
